import type { ReactNode } from 'react';
import { cn } from '@giyus/ui';
import { HomeCalendar } from './HomeCalendar';
// Painel da página inicial (pedido t31u): fila "Precisa da sua atenção", alertas por módulo e KPIs de estudos com gráficos.
// Cada bloco só aparece/consulta o que a autorização do escopo permite; sem dados reais há estado vazio, nunca exemplo.
import { usePermissions } from '../lib/permissions/usePermission';
import { buildNavItems } from '../shell/navItems';
import { AttentionPanel } from './AttentionPanel';
import { ModuleAlerts } from './ModuleAlerts';
import { StudyKpis } from './StudyKpis';
import { type HomeScope, useHomeSignals } from './useHomeSignals';

export interface HomeDashboardProps {
  readonly header?: ReactNode;
  readonly scope: HomeScope;
  /** Código do tenant ativo (escopo tenant) ou `null` (rede). */
  readonly tenantCode: string | null;
  readonly tenantId: string | null;
}

export function HomeDashboard({ scope, tenantCode, tenantId, header }: HomeDashboardProps) {
  const permissions = usePermissions(scope);
  const signals = useHomeSignals(scope, permissions);
  const navItems = buildNavItems(scope, tenantCode, permissions);
  const basePath = scope === 'network' ? '/network' : `/t/${encodeURIComponent(tenantCode ?? '')}`;
  const schedulingPath = navItems.find((item) => item.key === 'scheduling')?.to;
  return (
    <div
      className={cn(
        'grid min-w-0 gap-8',
        schedulingPath && 'xl:grid-cols-[minmax(0,1fr)_var(--home-aside-w)]',
      )}
      data-testid="home-dashboard"
      data-scope={scope}
    >
      <div className="min-w-0 space-y-7">
        {header}
        <StudyKpis scope={scope} basePath={basePath} signals={signals} display="summary" />
        <AttentionPanel scope={scope} basePath={basePath} tenantId={tenantId} signals={signals} />
        <ModuleAlerts scope={scope} navItems={navItems} signals={signals} />
        <StudyKpis scope={scope} basePath={basePath} signals={signals} display="charts" />
      </div>
      {schedulingPath && (
        <aside className="min-w-0">
          <HomeCalendar schedulingPath={schedulingPath} />
        </aside>
      )}
    </div>
  );
}
